import React from 'react';
import List from '../../matter/List';
import { useParams, useHistory, useLocation } from 'react-router';

const SpaceMatterList = () => {
  const params = useParams<{
    spaceUuid: string;
  }>();
  const history = useHistory();
  const location = useLocation();

  return <List spaceUuid={params.spaceUuid} history={history} location={location} />;
};

export default SpaceMatterList;
